var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full flex justify-end bottom-0 pb-3 pr-5 lg:pr-16 transition"},[_c('button',{staticClass:"text-2xl",on:{"click":_vm.scrollToTop}},[_c('fa-icon',{attrs:{"icon":"fa-solid fa-arrow-up"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }